import { Form } from '../../forms-templates/models';
import { NotificationLevel } from '../enums';
import { EntityType } from './entity.model';

export class Category {
  constructor(
    public id = 0,
    public name = '',
    public entity_types: EntityType[] = null,
    public phi = false,
    public override_phi = false,
    public patient_only = false,
    public override_patient_only = false,
    public mobile_visible = false,
    public override_mobile_visible = false,
    public created_by_super_admin = false,
    public notification_level: NotificationLevel = null,
    public compliance: { ids: number[]; is_edited?: boolean } = null,
    public form: Form = null,
  ) {}
}
